import type { ObjectValues } from 'utils/types.ts';

export const ZONE_IDS = {
	DETAIL_INZERATU: 75741,
	PATICKA: 75742,
	PATICKA_MOBIL: 75743,
	PATICKA_MOBIL_TEST: 386062,
	VYPIS_INZERATU: 77861,
	VYPIS_INZERATU_MOBIL: 77866,
	VYPIS_INZERATU_ASTRO: 348403,
};

export const ZONE = {
	[ZONE_IDS.PATICKA]: {
		width: 970,
		height: 310,
	},
	[ZONE_IDS.PATICKA_MOBIL]: {
		width: 480,
		height: 480,
	},
	[ZONE_IDS.PATICKA_MOBIL_TEST]: {
		width: 480,
		height: 480,
	},
};

const SSP_ADVERT_CONSTANTS = {
	HP_SECTION: '/hp',

	AD_FULL_EVENT: 'sspAdFull',
	ADDITIONAL_OFFERS_MIN_COUNT: 5, // Do not show the ad if there are fewer than this amount of additional offers
	ADDITIONAL_OFFERS_ADVERT_POSITION: 3, // Indexed from 0
} as const;

export type AdvertZoneId = ObjectValues<typeof ZONE_IDS>;

export default SSP_ADVERT_CONSTANTS;
